window.tcgPartsCatalogueData = {
  "generatedAt": "2026-06-25T00:27:53.285Z",
  "source": "TCG Shopify Admin active products joined to CMW dealer mapping",
  "categories": [
    {
      "slug": "security",
      "label": "Security",
      "short": "Lock boxes, locks, and theft-deterrent hardware.",
      "count": 4
    },
    {
      "slug": "ventilation",
      "label": "Ventilation",
      "short": "Passive vents, powered vents, fans, and screens.",
      "count": 10
    },
    {
      "slug": "framing-systems",
      "label": "Framing Systems",
      "short": "Steel stud, strut, and structural mounting systems.",
      "count": 15
    },
    {
      "slug": "windows-door-kits",
      "label": "Windows & Door Kits",
      "short": "Windows, man doors, roll-up doors, patio frames, and opening kits.",
      "count": 14
    },
    {
      "slug": "electrical-solar",
      "label": "Electrical / Solar",
      "short": "PortPlugs, solar mounting, and electrical-adjacent products.",
      "count": 3
    },
    {
      "slug": "storage-shelving-racking",
      "label": "Storage / Shelving / Racking",
      "short": "Shelving brackets, hooks, baskets, racks, and organization.",
      "count": 12
    },
    {
      "slug": "access-ramps-stairs",
      "label": "Access / Ramps / Stairs",
      "short": "Ramps and access products for loading or daily use.",
      "count": 3
    },
    {
      "slug": "hardware-components",
      "label": "Hardware / Components",
      "short": "Twist locks, bridge fittings, flashing, pads, and repair components.",
      "count": 21
    }
  ],
  "products": [
    {
      "handle": "fjm-80-mm-shackle-lock",
      "title": "CWM™ 80 mm Shackle Lock",
      "category": "security",
      "categoryLabel": "Security",
      "type": "Locks",
      "vendor": "Container Modification World",
      "price": "$34.95",
      "status": "Available",
      "url": "/products/fjm-80-mm-shackle-lock",
      "cmwUrl": "https://containermodificationworld.com/80mm-cmw-shackle-lock",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/80mm-CWM-Shackle-lock.png?v=1767037125",
      "imageAlt": "CMW stainless steel high-security padlock with three unique keys, designed for shipping containers and storage units; features a shrouded shackle for maximum cut and corrosion resistance.",
      "summary": "Ideal shipping container lock for one-time use shipping containers that include a factory lock box, or when using an aftermarket regular lock box on used containers.",
      "sku": "CMW-5A-130-0038 | CMW-5A-130-0039",
      "search": "cwm™ 80 mm shackle lock fjm-80-mm-shackle-lock locks container modification world container lock box container lock box door guard lock box container shackle lock fjm 60 mm fjm 80 mm shackle lock shipping container lock cmw-5a-130-0038 | cmw-5a-130-0039 security"
    },
    {
      "handle": "universal-shipping-container-lock-box",
      "title": "DoorGuard™ Lock Box",
      "category": "security",
      "categoryLabel": "Security",
      "type": "Lock Box",
      "vendor": "Container Modification World",
      "price": "$119.95 - $149.95",
      "status": "Available",
      "url": "/products/universal-shipping-container-lock-box",
      "cmwUrl": "https://containermodificationworld.com/products/universal-shipping-container-lock-box",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/NEW_Lock_Box_Combo_Main.png?v=1767042666",
      "imageAlt": "Lock box and 80mm shackle lock bundle with hardware for shipping containers, cargo trailers, and man doors",
      "summary": "Patented design made to protect left and right-hand man doors, shipping containers/sea cans (all sizes) & cargo trailers.",
      "sku": "CMW-5K-120-0425 | CMW-5K-120-0423 | CMW-5K-120-0424",
      "search": "doorguard™ lock box universal-shipping-container-lock-box lock box container modification world 80mm lock cargo trailer security container security fjm80mm lock box lockbox sea can security cmw-5k-120-0425 | cmw-5k-120-0423 | cmw-5k-120-0424 security"
    },
    {
      "handle": "container-modification-world-5340-universal-bolt-on-lock-box",
      "title": "Shipping Container Lock Box",
      "category": "security",
      "categoryLabel": "Security",
      "type": "Lock Box",
      "vendor": "Container Modification World",
      "price": "$99.95",
      "status": "Available",
      "url": "/products/container-modification-world-5340-universal-bolt-on-lock-box",
      "cmwUrl": "https://containermodificationworld.com/products/container-modification-world-5340-universal-bolt-on-lock-box",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/lockbox-set-white-bg-decal.png?v=1767125920",
      "imageAlt": "Right Hand Container Lock Box Kit with powder-coated black lock box, laser-cut steel mounting plates, Grade 5 carriage bolts, washers, and nuts — fits 20', 40', and 53' shipping containers and van trailers",
      "summary": "Features: Fits: 7', 8', 9', 10', 20', 40', 45', 48' & 53' Shipping Containers Designed to be only 5.5\" to fit between lock rods on 53' containers and van trailers.",
      "sku": "CMW-5K-120-0726",
      "search": "shipping container lock box container-modification-world-5340-universal-bolt-on-lock-box lock box container modification world black lock box container lock container lock box container security lock box sea can lock box shipping container lock box cmw-5k-120-0726 security"
    },
    {
      "handle": "door-guard-lock-box",
      "title": "Shipping Container Lock Box with Lock",
      "category": "security",
      "categoryLabel": "Security",
      "type": "Lock Box",
      "vendor": "Container Modification World",
      "price": "$129.95",
      "status": "Available",
      "url": "/products/door-guard-lock-box",
      "cmwUrl": "https://containermodificationworld.com/products/door-guard-lock-box",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/NEW_Lock_Box_Combo_Deca.png?v=1767350103",
      "imageAlt": "A lock box kit with a black textured powder-coated finish, including a lock, keys, mounting hardware, and a back washer plate.",
      "summary": "Designed around and comes with an 80mm shackle lock (FJM, SOBO, 8080). The housing unit protects the lock from being cut by bolt cutters.",
      "sku": "CMW-5K-120-0724 | CMW-5K-120-0725",
      "search": "shipping container lock box with lock door-guard-lock-box lock box container modification world cargo trailer security container lock box door guard lock box lock box with key polaris sleds sea can security shipping container lock sledders snowmobile theft cmw-5k-120-0724 | cmw-5k-120-0725 security"
    },
    {
      "handle": "bigair30-louvered-gable-vent-bug-screen-attachments-only-2-pack",
      "title": "BIG AIR® 30 Louvered Gable Vent BUG SCREEN ATTACHMENTS ONLY (2 Pack)",
      "category": "ventilation",
      "categoryLabel": "Ventilation",
      "type": "Ventilation",
      "vendor": "Container Modification World",
      "price": "$49.95",
      "status": "Available",
      "url": "/products/bigair30-louvered-gable-vent-bug-screen-attachments-only-2-pack",
      "cmwUrl": "https://containermodificationworld.com/products/bigair30-louvered-gable-vent-bug-screen-attachments-only-2-pack",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/bibgair30bugscreensonly.png?v=1759954920",
      "imageAlt": "Two pack BigAir30 louvered gable vent bug screen attachments for insect protection",
      "summary": "BIG AIR® 30 Louvered Gable Vent BUG SCREEN ATTACHMENTS ONLY (2 Pack)",
      "sku": "CMW-1K-100-0685",
      "search": "big air® 30 louvered gable vent bug screen attachments only (2 pack) bigair30-louvered-gable-vent-bug-screen-attachments-only-2-pack ventilation container modification world big air 30 vent big air container vent bug screen container vent container vents container windows cmw-1k-100-0685 ventilation"
    },
    {
      "handle": "bigair30-louvered-gable-vent-2-pack",
      "title": "BIG AIR® 30 Louvered Gable Vents",
      "category": "ventilation",
      "categoryLabel": "Ventilation",
      "type": "Vent",
      "vendor": "Container Modification World",
      "price": "$179.95 - $229.95",
      "status": "Available",
      "url": "/products/bigair30-louvered-gable-vent-2-pack",
      "cmwUrl": "https://containermodificationworld.com/bigair30-vents",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/BIgAir30-louvered-gable-vents.png?v=1767041843",
      "imageAlt": "BIgAir30 louvered gable vents with the BigAir brand logo, designed for installation on shipping containers.",
      "summary": "BIG AIR® Louvered Container Vents are engineered to be installed anywhere on shipping container sidewalls, end walls, or doors - from floor to ceiling.",
      "sku": "CMW-1K-110-0354 | CMW-1K-110-0706",
      "search": "big air® 30 louvered gable vents bigair30-louvered-gable-vent-2-pack vent container modification world big air 30 vent big air container vent bigair30 sea can vent sea can ventilation shipping container vent cmw-1k-110-0354 | cmw-1k-110-0706 ventilation"
    },
    {
      "handle": "new-big-air-400-cfm-solar-powered-roof-vent-w-bug-screen",
      "title": "BIG AIR® 400 CFM Solar Powered Roof Vent/Fan",
      "category": "ventilation",
      "categoryLabel": "Ventilation",
      "type": "Ventilation",
      "vendor": "Container Modification World",
      "price": "$349.95 - $599.95",
      "status": "Available",
      "url": "/products/new-big-air-400-cfm-solar-powered-roof-vent-w-bug-screen",
      "cmwUrl": "https://containermodificationworld.com/solar-roof-vent",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/BigAir-400-CFM-sloar-powered-roof-vent-fan.png?v=1767041996",
      "imageAlt": "Canada Go Green 4 Seasons Solar Vent with removable aluminum bug screen and metal flashing kit, designed for shipping containers and trailers. Features a 10W monocrystalline solar panel, 400 CFM airflow, anti-UV/freeze ABS-PC construction, and quiet, vibration-free operation",
      "summary": "400 CFM provides a complete air exchange every 3 minutes in a 20 ft container and every 6 minutes in a 40 ft container under ideal conditions.",
      "sku": "CMW-1K-230-0419 | CMW-1K-230-0420 | CMW-1K-230-0421",
      "search": "big air® 400 cfm solar powered roof vent/fan new-big-air-400-cfm-solar-powered-roof-vent-w-bug-screen ventilation container modification world roof vent shipping container ventilation solar powered roof fan sea can solar powered roof vent for shipping containers vent for corrugated steel cmw-1k-230-0419 | cmw-1k-230-0420 | cmw-1k-230-0421 ventilation"
    },
    {
      "handle": "bigair-passive-shipping-container-vents",
      "title": "BIG AIR® 45 Louvered Gable Vents",
      "category": "ventilation",
      "categoryLabel": "Ventilation",
      "type": "Home & Kitchen",
      "vendor": "Container Modification World",
      "price": "$199.95 - $249.95",
      "status": "Available",
      "url": "/products/bigair-passive-shipping-container-vents",
      "cmwUrl": "https://containermodificationworld.com/bigair45-vents",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/BIgAir45-Louvered-gable-vent.png?v=1767041919",
      "imageAlt": "Set of two BigAir Louvered Container Vents with corrosion-resistant aluminum frame, designed for easy installation on shipping container walls, doors, or end panels to improve airflow and reduce heat and moisture",
      "summary": "BIG AIR® Louvered Container Vents are engineered to be installed anywhere on shipping container sidewalls, end walls, or doors - from floor to ceiling.",
      "sku": "CMW-1K-110-0683 | CMW-1K-110-0684",
      "search": "big air® 45 louvered gable vents bigair-passive-shipping-container-vents home & kitchen container modification world bigair45 louvered vent container vent cool off sea can remove heat from shipping container sea can exhaust vents sea can vent sea can ventilation shipping container intake vents shipping container vents cmw-1k-110-0683 | cmw-1k-110-0684 ventilation"
    },
    {
      "handle": "bigair-45-screen-mesh-attachments-2-pack",
      "title": "BIG AIR® 45 Screen Mesh Attachments (2 Pack)",
      "category": "ventilation",
      "categoryLabel": "Ventilation",
      "type": "Ventilation",
      "vendor": "Container Modification World",
      "price": "$49.95",
      "status": "Available",
      "url": "/products/bigair-45-screen-mesh-attachments-2-pack",
      "cmwUrl": "https://containermodificationworld.com/bigair45-screen-attachments",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/NEW_Website_Main_Screen_Mesh_Attachments.png?v=1761756991",
      "imageAlt": "Screen mesh attachments for BigAir 45 vent – includes No.8 1/2\" wafer head self-tapping screws",
      "summary": "THESE ARE SCREEN MESH ATTACHMENTS ONLY For anyone who has purchased a basic BIG AIR® 45 vent in the past without a screen mesh.",
      "sku": "CMW-1K-100-0686",
      "search": "big air® 45 screen mesh attachments (2 pack) bigair-45-screen-mesh-attachments-2-pack ventilation container modification world big air 45 bigair45 screen bug screen nigair45 screen mesh attchment vent screen cmw-1k-100-0686 ventilation"
    },
    {
      "handle": "bigair-57-cfm-solar-vent",
      "title": "BIG AIR® 57 CFM Solar Vent",
      "category": "ventilation",
      "categoryLabel": "Ventilation",
      "type": "Ventilation",
      "vendor": "Container Modification World",
      "price": "$179.95",
      "status": "Available",
      "url": "/products/bigair-57-cfm-solar-vent",
      "cmwUrl": "https://containermodificationworld.com/bigair-57-cfm-solar-vent",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/BigAir-57CFM-solar-vent.png?v=1767041940",
      "imageAlt": "BigAir 57 CFM solar vent with aluminum frame designed for shipping container ventilation, reducing moisture and heat buildup",
      "summary": "BIG AIR® 57 CFM Solar Vent The custom-designed aluminum framing kit allows the BIG AIR® 57 CFM Solar Vent to be installed anywhere on shipping container sidewalls, end walls, or...",
      "sku": "CMW-1K-210-1453",
      "search": "big air® 57 cfm solar vent bigair-57-cfm-solar-vent ventilation container modification world shipping container vent shipping container ventilation shipping container vents solar vent cmw-1k-210-1453 ventilation"
    },
    {
      "handle": "bigair30-louvered-gable-vent-bug-screen-attachments-only-2-pack-1",
      "title": "BIG AIR® 60 Louvered Gable Vent BUG SCREEN ATTACHMENTS ONLY (2 Pack)",
      "category": "ventilation",
      "categoryLabel": "Ventilation",
      "type": "Ventilation",
      "vendor": "Container Modification World",
      "price": "$69.95",
      "status": "Available",
      "url": "/products/bigair30-louvered-gable-vent-bug-screen-attachments-only-2-pack-1",
      "cmwUrl": "https://containermodificationworld.com/products/bigair30-louvered-gable-vent-bug-screen-attachments-only-2-pack-1",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/BigAir60BugScreensOnly2Pack.png?v=1760126886",
      "imageAlt": "Two BigAir60 louvered gable vent bug screen attachments for insect protection!",
      "summary": "BIG AIR® 30 Louvered Gable Vent BUG SCREEN ATTACHMENTS ONLY (2 Pack)",
      "sku": "CMW-1K-100-0687",
      "search": "big air® 60 louvered gable vent bug screen attachments only (2 pack) bigair30-louvered-gable-vent-bug-screen-attachments-only-2-pack-1 ventilation container modification world cmw-1k-100-0687 ventilation"
    },
    {
      "handle": "bigair60-louvered-gable-vent-2-pack",
      "title": "BIG AIR® 60 Louvered Gable Vents",
      "category": "ventilation",
      "categoryLabel": "Ventilation",
      "type": "Ventilation",
      "vendor": "Container Modification World",
      "price": "$249.95 - $319.95",
      "status": "Available",
      "url": "/products/bigair60-louvered-gable-vent-2-pack",
      "cmwUrl": "https://containermodificationworld.com/bigair60-vents",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/BIgAir60-louvered-gable-vents.png?v=1767041973",
      "imageAlt": "two BigAir60 louvered gable vents for shipping containers.",
      "summary": "BIG AIR® Louvered Container Vents are engineered to be installed anywhere on shipping container sidewalls, end walls, or doors - from floor to ceiling.",
      "sku": "CMW-1K-110-0355 | CMW-1K-110-0707",
      "search": "big air® 60 louvered gable vents bigair60-louvered-gable-vent-2-pack ventilation container modification world big air 60 container vents bigair60 container vents bigair60 sea can vents container ventilation container vents sea can ventilation shipping container vents cmw-1k-110-0355 | cmw-1k-110-0707 ventilation"
    },
    {
      "handle": "big-air-sky-light-roof-vent-for-preventing-condensation-and-excessive-heat-in-new-and-used-sea-cans-shipping-container-homes-cabins-and-offices",
      "title": "BIG AIR® Sky Light Roof Vent",
      "category": "ventilation",
      "categoryLabel": "Ventilation",
      "type": "Vent",
      "vendor": "Container Modification World",
      "price": "$249.95",
      "status": "Available",
      "url": "/products/big-air-sky-light-roof-vent-for-preventing-condensation-and-excessive-heat-in-new-and-used-sea-cans-shipping-container-homes-cabins-and-offices",
      "cmwUrl": "https://containermodificationworld.com/bigair-skylight-roof-vent",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/skylight-main-amazon.png?v=1767042026",
      "imageAlt": "A white square-shaped BigAir Sky Light Vent installed on a metal-framed base, designed for use on shipping container rooftops.",
      "summary": "Designed to be installed anywhere on shipping containers, van trailers & all wood construction building rooftops.",
      "sku": "CMW-1K-210-0549",
      "search": "big air® sky light roof vent big-air-sky-light-roof-vent-for-preventing-condensation-and-excessive-heat-in-new-and-used-sea-cans-shipping-container-homes-cabins-and-offices vent container modification world container vent shipping container sky light shipping container skylight shipping container ventilation shipping container vents cmw-1k-210-0549 ventilation"
    },
    {
      "handle": "t10-air-lift-exhaust-fan-w-temperature-and-humidity-controller-2-x-10-aluminum-intake-gravity-louvers-bundle-pack",
      "title": "BIG AIR® T10 Air Lift (631 CFM) Electric Exhaust Fan",
      "category": "ventilation",
      "categoryLabel": "Ventilation",
      "type": "Vent",
      "vendor": "Container Modification World",
      "price": "$494.95 - $974.95",
      "status": "Available",
      "url": "/products/t10-air-lift-exhaust-fan-w-temperature-and-humidity-controller-2-x-10-aluminum-intake-gravity-louvers-bundle-pack",
      "cmwUrl": "https://containermodificationworld.com/t10-electric-fan",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/t10-air-lift-fan.png?v=1767043242",
      "imageAlt": "A black exhaust fan with metal frame and shutters, designed for installation in shipping containers.",
      "summary": "The T10 Air Lift Exhaust Fan w/ Temperature and Humidity Controller is powered by AC Infinity.",
      "sku": "CMW-1K-220-0350 | CMW-1K-130-0352 | CMW-1K-240-0063",
      "search": "big air® t10 air lift (631 cfm) electric exhaust fan t10-air-lift-exhaust-fan-w-temperature-and-humidity-controller-2-x-10-aluminum-intake-gravity-louvers-bundle-pack vent container modification world electric exhaust fan shipping container intake vents sea can shipping container electric fans shipping container electric vents cmw-1k-220-0350 | cmw-1k-130-0352 | cmw-1k-240-0063 ventilation"
    },
    {
      "handle": "2-corner-casting-covers-for-steel-stud-framing-steel-stud-brackets-not-included",
      "title": "2 Corner Casting Covers For Steel Stud Framing (Steel Stud Brackets Not Included)",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Framing",
      "vendor": "Container Modification World",
      "price": "$99.95",
      "status": "Available",
      "url": "/products/2-corner-casting-covers-for-steel-stud-framing-steel-stud-brackets-not-included",
      "cmwUrl": "https://containermodificationworld.com/corner-casting-covers",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/2-Corner-Casting-Covers.png?v=1767989969",
      "imageAlt": "Two Corner Casting Covers made of silver steel with visible screws, designed for connecting steel studs in wall framing.",
      "summary": "Corner casting covers connect the studs and provide a 2\" gap from the wall for spray foam.",
      "sku": "CMW-5K-300-0377",
      "search": "2 corner casting covers for steel stud framing (steel stud brackets not included) 2-corner-casting-covers-for-steel-stud-framing-steel-stud-brackets-not-included framing container modification world corner casting covers steel stud framing cmw-5k-300-0377 framing systems"
    },
    {
      "handle": "double-wide-shipping-container-connection-kit-with-weld-free-header",
      "title": "40' Double-Wide Shipping Container Connection Kit with Weld-Free Header - BETA 1.0",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Structural Kit",
      "vendor": "Container Modification World",
      "price": "$4,995 - $5,495",
      "status": "Available",
      "url": "/products/double-wide-shipping-container-connection-kit-with-weld-free-header",
      "cmwUrl": "https://containermodificationworld.com/40ft-double-wide-kit",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/IMG_7700.png?v=1767127910",
      "imageAlt": "40' Double-Wide Shipping Container Connection Kit with Weld-Free Header - BETA 1.0",
      "summary": "Double-Wide Shipping Container Connection Kit with Weld-Free Header Transform two 40 ft High Cube (New/One Time Use) shipping containers into one spacious 40' x 16' structure wi...",
      "sku": "CMW-4K-740-1345 | CMW-4K-740-1764",
      "search": "40' double-wide shipping container connection kit with weld-free header - beta 1.0 double-wide-shipping-container-connection-kit-with-weld-free-header structural kit container modification world 40 ft double wide kit container roof double wide join 2 containers join two containers roof structure cmw-4k-740-1345 | cmw-4k-740-1764 framing systems"
    },
    {
      "handle": "csm-bracket",
      "title": "Container Strut Mount (CSM™ ) Galvanized Framing Brackets (10 Pack)",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Framing",
      "vendor": "Container Modification World",
      "price": "$174.95",
      "status": "Available",
      "url": "/products/csm-bracket",
      "cmwUrl": "https://containermodificationworld.com/csm-brackets",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/new-galv-csm-bracket-shopify-image.png?v=1767042572",
      "imageAlt": "Modular Strut Systems Container Strut Mount (CSM) premium galvanized bracket kit, featuring heavy-duty base and angle bracket for mounting strut channels inside ISO shipping containers.",
      "summary": "Container Strut Mount (CSM™) Galvanized Framing Brackets (10 Pack), allow for hassle-free mounting of strut channels inside any shipping container with ISO 9910 corrugations.",
      "sku": "CMW-4K-110-1154",
      "search": "container strut mount (csm™ ) galvanized framing brackets (10 pack) csm-bracket framing container modification world container shelving framing shipping container how to frame a sea can unistrut brackets cmw-4k-110-1154 framing systems"
    },
    {
      "handle": "csm-upper-decker-bracket",
      "title": "CSM™ Heavy Duty Upper Decker Roof Bracket",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Framing",
      "vendor": "Container Modification World",
      "price": "$34.95",
      "status": "Available",
      "url": "/products/csm-upper-decker-bracket",
      "cmwUrl": "https://containermodificationworld.com/products/csm-upper-decker-bracket",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/CSM-Heavy-duty-upper-decker-roof-bracket.png?v=1767042584",
      "imageAlt": "A black metal upper decker roof bracket with the Modular Strut Systems (MSS) logo and text indicating it's a premium bracket with a five-star rating.",
      "summary": "Premium CSM™ Heavy Duty Upper Decker Roof Brackets, generation 1 model. On sale $10 off!",
      "sku": "CMW-4K-210-0361",
      "search": "csm™ heavy duty upper decker roof bracket csm-upper-decker-bracket framing container modification world cmw-4k-210-0361 framing systems"
    },
    {
      "handle": "csm-strut-framing-bracket-packs",
      "title": "CSM™ Strut Framing Bracket Packs",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Framing",
      "vendor": "Container Modification World",
      "price": "$350 - $1,680",
      "status": "Available",
      "url": "/products/csm-strut-framing-bracket-packs",
      "cmwUrl": "https://containermodificationworld.com/products/csm-strut-framing-bracket-packs",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/10_Every3rdcorrigationCSM.png?v=1767042528",
      "imageAlt": "Container Strut Mount (CSM) Brackets for 10' shipping containers, shown in black powder-coated and galvanized finishes, with installation examples on side and end walls using every 3rd corrugation.",
      "summary": "Container Strut Mount (CSM™) Bracket Packs Strut Mount Brackets allow for hassle-free mounting of strut channels inside and outside any shipping container with ISO 9910 corrugat...",
      "sku": "CMW-4K-110-0810 | CMW-4K-110-0811 | CMW-4K-110-0812 | CMW-4K-110-0814 | CMW-4K-110-0815 | CMW-4K-110-0818 | CMW-4K-110-0819",
      "search": "csm™ strut framing bracket packs csm-strut-framing-bracket-packs framing container modification world csm brackets sea can framing shipping containe rframing strut framing strut mount framing cmw-4k-110-0810 | cmw-4k-110-0811 | cmw-4k-110-0812 | cmw-4k-110-0814 | cmw-4k-110-0815 | cmw-4k-110-0818 | cmw-4k-110-0819 framing systems"
    },
    {
      "handle": "exterior-wood-framing-bracket-kit-2-way-upper-decker-brackets",
      "title": "Exterior Wood Framing Bracket Kits",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Framing",
      "vendor": "Container Modification World",
      "price": "$414.95 - $1,849.95",
      "status": "Available",
      "url": "/products/exterior-wood-framing-bracket-kit-2-way-upper-decker-brackets",
      "cmwUrl": "https://containermodificationworld.com/ext-wood-framing-bracket-kits",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/ext_brackets.png?v=1772663757",
      "imageAlt": "Exterior Wood Framing Bracket Kits",
      "summary": "These brackets allow you to easily frame the exterior of a shipping container with wood.",
      "sku": "CMW-4K-220-0330 | CMW-4K-220-1368 | CMW-4K-220-0331 | CMW-4K-220-1369",
      "search": "exterior wood framing bracket kits exterior-wood-framing-bracket-kit-2-way-upper-decker-brackets framing container modification world 2 way wood stud framing brackets shipping container exterior brackets wood framing cmw-4k-220-0330 | cmw-4k-220-1368 | cmw-4k-220-0331 | cmw-4k-220-1369 framing systems"
    },
    {
      "handle": "container-strut-mount-csm-roof-brackets",
      "title": "Galvanized Container Strut Mount (CSM™) Roof Brackets",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Business & Industrial",
      "vendor": "Container Modification World",
      "price": "$29.95",
      "status": "Available",
      "url": "/products/container-strut-mount-csm-roof-brackets",
      "cmwUrl": "https://containermodificationworld.com/galv-csm-roof-brackets",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Galv_Amazon_Main.png?v=1764097009",
      "imageAlt": "Galvanized Container Strut Mount (CSM™) Roof Brackets",
      "summary": "Galvanized Steel Container Strut Mount (CSM™) Roof Brackets: Mount Solar panels and other components to the exterior roof of your shipping container or sea can.",
      "sku": "CMW-4K-210-0652",
      "search": "galvanized container strut mount (csm™) roof brackets container-strut-mount-csm-roof-brackets business & industrial container modification world csm roof bracket galvanized shipping container brackets solar brackets solar power mount brackets containers cmw-4k-210-0652 framing systems"
    },
    {
      "handle": "low-profile-double-wide-kit",
      "title": "Low Profile 20' Double Wide Kit (Weld-Free)",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Structural Kit",
      "vendor": "Container Modification World",
      "price": "Quote",
      "status": "Available",
      "url": "/products/low-profile-double-wide-kit",
      "cmwUrl": "https://containermodificationworld.com/products/low-profile-double-wide-kit",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/main_image_transparent_double_wide_container_kit.png?v=1767130948",
      "imageAlt": "Low Profile 20' Double Wide Kit (Weld-Free)",
      "summary": "Low Profile 20' Double-Wide Connection Kit (Weld-Free) Transform two 20 ft shipping containers into a seamless 20’ x 16’ open span structure - no welding required !",
      "sku": "68fa70d8d683c",
      "search": "low profile 20' double wide kit (weld-free) low-profile-double-wide-kit structural kit container modification world 20 ft double wide connection kit container corner castings doubel wide connection kit double wide joining kitbridge fittings join 2 containers join containers together join two containers low profile 20' double-wide 68fa70d8d683c framing systems"
    },
    {
      "handle": "mss-standard-galvanized-strut-mount-brackets",
      "title": "MSS™ Standard Galvanized Strut Mount Brackets",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Strut Bracket",
      "vendor": "Container Modification World",
      "price": "$7.50 - $20",
      "status": "Available",
      "url": "/products/mss-standard-galvanized-strut-mount-brackets",
      "cmwUrl": "https://containermodificationworld.com/mss-standard-galv-strut-mount-brackets",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Modular-Strut-System-_MSS_-Container-Strut_Brackets_No-Welding-or-Exterior-Screws-Needed_7ddb29b6-f94e-4294-bf50-effe474b6385.png?v=1767043015",
      "imageAlt": "A collection of four different galvanized strut mount brackets from Modular Strut Systems, displayed against a white background.",
      "summary": "No More Driving Screws Through Container Walls & No More Welding! Self-tapping screws or bolts protruding from the exterior are a safety hazard and will render your container un...",
      "sku": "CMW-4K-110-0719 | CMW-4K-110-0717 | CMW-4K-110-0716 | CMW-4K-110-0718",
      "search": "mss™ standard galvanized strut mount brackets mss-standard-galvanized-strut-mount-brackets strut bracket container modification world csm brackets galvanized strut brackets mss brackets sea can framing brackets shipping container framing strut brackets strut channel cmw-4k-110-0719 | cmw-4k-110-0717 | cmw-4k-110-0716 | cmw-4k-110-0718 framing systems"
    },
    {
      "handle": "strut-framing-bracket-packs",
      "title": "MSS™ Strut Framing Bracket Packs",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Strut Bracket",
      "vendor": "Container Modification World",
      "price": "$400 - $3,180",
      "status": "Available",
      "url": "/products/strut-framing-bracket-packs",
      "cmwUrl": "https://containermodificationworld.com/mss-framing-bracket-packs",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Modular-Strut-System-_MSS_-Bracket-Kit-for_10_Shipping_Containers_Galvanized_Steel_Mounts-for-Sidewall-and-End-Wall-installation.png?v=1767200951",
      "imageAlt": "Modular Strut System (MSS) brackets for 10-foot shipping containers—includes MSS 2-Way and MSS 1-Way strut mount brackets installed on sidewall and end wall corrugations. Ideal for mounting shelves, electrical panels, and strut channels without welding.",
      "summary": "Modular Strut System (MSS™) Strut Mount Brackets allow for hassle-free mounting of strut channels inside and outside any shipping container with ISO 9910 corrugations.",
      "sku": "CMW-4K-110-0820 | CMW-4K-110-0821 | CMW-4K-110-0822 | CMW-4K-110-0823 | CMW-4K-110-0824 | CMW-4K-110-0825 | CMW-4K-110-0826 | CMW-4K-110-0827 | CMW-4K-110-0828 | CMW-4K-110-0829 | CMW-4K-110-0830 | CMW-4K-110-0831",
      "search": "mss™ strut framing bracket packs strut-framing-bracket-packs strut bracket container modification world modular strut systems mss brackets strut brackets cmw-4k-110-0820 | cmw-4k-110-0821 | cmw-4k-110-0822 | cmw-4k-110-0823 | cmw-4k-110-0824 | cmw-4k-110-0825 | cmw-4k-110-0826 | cmw-4k-110-0827 | cmw-4k-110-0828 | cmw-4k-110-0829 | cmw-4k-110-0830 | cmw-4k-110-0831 framing systems"
    },
    {
      "handle": "container-modification-world®-12-gauge-aluminum-framing-brackets-for-steel-stud-framing-the-inside-of-shipping-containers",
      "title": "SSB™ 12 Gauge Aluminum Steel Stud Framing Brackets",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Steel Stud Bracket",
      "vendor": "Container Modification World",
      "price": "$99.95 - $299.95",
      "status": "Available",
      "url": "/products/container-modification-world%C2%AE-12-gauge-aluminum-framing-brackets-for-steel-stud-framing-the-inside-of-shipping-containers",
      "cmwUrl": "https://containermodificationworld.com/products/container-modification-world®-12-gauge-aluminum-framing-brackets-for-steel-stud-framing-the-inside-of-shipping-containers",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/steel-stud-bracket-for-containers-amazon_main_01_new_3d.png?v=1767635011",
      "imageAlt": "A silver aluminum steel stud framing bracket with multiple holes for screws.",
      "summary": "12-gauge aluminum brackets designed for steel stud framing inside shipping containers.",
      "sku": "CMW-4K-120-0800 | CMW-4K-120-0801 | CMW-4K-120-0802",
      "search": "ssb™ 12 gauge aluminum steel stud framing brackets container-modification-world®-12-gauge-aluminum-framing-brackets-for-steel-stud-framing-the-inside-of-shipping-containers steel stud bracket container modification world framing brackets for shipping containers steel stud steel stud brackets framing aluminum cmw-4k-120-0800 | cmw-4k-120-0801 | cmw-4k-120-0802 framing systems"
    },
    {
      "handle": "composite-steel-stud-framing-brackets-for-shipping-containers-sea-cans",
      "title": "SSB™ Composite Steel Stud Framing Brackets",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Steel Stud Bracket",
      "vendor": "Container Modification World",
      "price": "$74.95 - $299.95",
      "status": "Available",
      "url": "/products/composite-steel-stud-framing-brackets-for-shipping-containers-sea-cans",
      "cmwUrl": "https://containermodificationworld.com/composite-steel-stud-framing-brackets",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Composite-Steel-Stud-Brackets-for-Shipping-Container-Interiors.png?v=1767042220",
      "imageAlt": "Composite steel stud brackets designed for interior shipping container framing with spray foam insulation",
      "summary": "Based on the original 12 Gauge Aluminum Steel Stud Brackets (SSB™) from Container Modification World.",
      "sku": "CMW-4K-120-1009 | CMW-4K-120-1010 | CMW-4K-120-1011",
      "search": "ssb™ composite steel stud framing brackets composite-steel-stud-framing-brackets-for-shipping-containers-sea-cans steel stud bracket container modification world composite brackets composite steel stud brackets steel stud steel stud brackets framing aluminum steel stud framing cmw-4k-120-1009 | cmw-4k-120-1010 | cmw-4k-120-1011 framing systems"
    },
    {
      "handle": "steel-stud-framing-kit-for-shipping-containers-sea-cans-2-corner-casting-covers-steel-stud-brackets-hardware",
      "title": "SSB™ Steel Stud Framing Kit (12 Gauge Aluminum Brackets)  - 2 Corner Casting Covers + Steel Stud Brackets + Hardware",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Steel Stud Bracket",
      "vendor": "Container Modification World",
      "price": "$199.95 - $499.95",
      "status": "Available",
      "url": "/products/steel-stud-framing-kit-for-shipping-containers-sea-cans-2-corner-casting-covers-steel-stud-brackets-hardware",
      "cmwUrl": "https://containermodificationworld.com/aluminum-ssb-corner-casting-cover-kits",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/aluminum-corner-casting-with-steel-stud-framing-brackets.png?v=1767128292",
      "imageAlt": "The image shows two corner casting covers made of aluminum, along with text indicating the quantity and type of items included in the kit, i.e.",
      "summary": "This kit allows for easy DIY installation of steel studs inside a container. Corner Casting Covers connect the studs and provide a 2\" gap from the wall for spray Foam.",
      "sku": "CMW-4K-120-0720 | CMW-4K-120-0721 | CMW-4K-120-0722",
      "search": "ssb™ steel stud framing kit (12 gauge aluminum brackets)  - 2 corner casting covers + steel stud brackets + hardware steel-stud-framing-kit-for-shipping-containers-sea-cans-2-corner-casting-covers-steel-stud-brackets-hardware steel stud bracket container modification world bracket corner casting covers steel stud steel stud brackets framing aluminum cmw-4k-120-0720 | cmw-4k-120-0721 | cmw-4k-120-0722 framing systems"
    },
    {
      "handle": "composite-steel-stud-framing-kit-for-shipping-containers-sea-cans-2-corner-casting-covers-composite-steel-stud-brackets-hardware",
      "title": "SSB™ Steel Stud Framing Kit (Corner Casting Covers + Composite Steel Stud Brackets + Hardware)",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Steel Stud Bracket",
      "vendor": "Container Modification World",
      "price": "$199.95 - $499.95",
      "status": "Available",
      "url": "/products/composite-steel-stud-framing-kit-for-shipping-containers-sea-cans-2-corner-casting-covers-composite-steel-stud-brackets-hardware",
      "cmwUrl": "https://containermodificationworld.com/composite-ssb-corner-casting-cover-kits",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Composite_Steel_Stud_Bracket_Corner_Casting_Cover_Kit-for-Shipping-Container-Interior-Framing.png?v=1767042368",
      "imageAlt": "Composite steel stud brackets and corner casting covers for interior shipping container framing, designed to support spray foam insulation and reduce thermal conductivity.",
      "summary": "This Kit Allows for Easy DIY Installation of Composite Steel Studs and Corner Casting Covers Inside a Container.",
      "sku": "CMW-4K-120-1042 | CMW-4K-120-1043 | CMW-4K-120-1044",
      "search": "ssb™ steel stud framing kit (corner casting covers + composite steel stud brackets + hardware) composite-steel-stud-framing-kit-for-shipping-containers-sea-cans-2-corner-casting-covers-composite-steel-stud-brackets-hardware steel stud bracket container modification world composite steel stud brackets container corner castings corner casting covers steel stud steel stud brackets framing aluminum steel stud framing cmw-4k-120-1042 | cmw-4k-120-1043 | cmw-4k-120-1044 framing systems"
    },
    {
      "handle": "diy-wood-truss-brackets-for-shipping-containers-no-welding",
      "title": "Wood Truss Bracket Kits",
      "category": "framing-systems",
      "categoryLabel": "Framing Systems",
      "type": "Roof Bracket",
      "vendor": "Container Modification World",
      "price": "$249.95 - $899.95",
      "status": "Available",
      "url": "/products/diy-wood-truss-brackets-for-shipping-containers-no-welding",
      "cmwUrl": "https://containermodificationworld.com/wood-truss-brackets",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Wood-Truss-Bracket.png?v=1761312989",
      "imageAlt": "Galvanized steel wood truss bracket for installing wood roofs on shipping containers without interior holes",
      "summary": "DIY Wood Truss Brackets For Shipping Containers Install a wood roof on top of a shipping container - without poking any holes into the interior!",
      "sku": "CMW-4K-220-1277 | CMW-4K-220-1278 | CMW-4K-220-1279",
      "search": "wood truss bracket kits diy-wood-truss-brackets-for-shipping-containers-no-welding roof bracket container modification world container roof roof sea cansea can roof truss truss brackets wood wood framing wood stud brackets cmw-4k-220-1277 | cmw-4k-220-1278 | cmw-4k-220-1279 framing systems"
    },
    {
      "handle": "galvanized-steel-man-door-framing-kit",
      "title": "36\" Insulated Steel Man Door & Frame Kit (Slab, Lever, Sweep & Hinges)",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "Doors",
      "vendor": "Container Modification World",
      "price": "$1,650",
      "status": "Available",
      "url": "/products/galvanized-steel-man-door-framing-kit",
      "cmwUrl": "https://containermodificationworld.com/steel-man-door-kit",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/new_32_x_80_man_door_amazon_main.png?v=1767042877",
      "imageAlt": "Galvanized steel man door frame kit for shipping containers, shown with pre-installed door and hardware for easy container access.",
      "summary": "Gain easy access to your containers with our commercial-grade man door framing kit.",
      "sku": "CMW-2K-110-0007",
      "search": "36\" insulated steel man door & frame kit (slab, lever, sweep & hinges) galvanized-steel-man-door-framing-kit doors container modification world container door door frame dual swinger man door framing kit seacan door cmw-2k-110-0007 windows & door kits"
    },
    {
      "handle": "new-42-side-wall-window-framing-kit",
      "title": "42\" x 30\" Side Wall Vinyl Sliding Window Framing Kit",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "windows",
      "vendor": "Container Modification World",
      "price": "$394.95",
      "status": "Available",
      "url": "/products/new-42-side-wall-window-framing-kit",
      "cmwUrl": "https://containermodificationworld.com/42x30-side-wall-window-framing-kit",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/42inchvinylwindowforshippingcontainerFRONT.png?v=1767041758",
      "imageAlt": "42\" x 30\" Side Wall Vinyl Sliding Window Framing Kit",
      "summary": "NEW & IMPROVED DESIGN! Framing kits allow for quick and easy installation of any appropriately sized window with a vinyl nailing strip.",
      "sku": "CMW-2K-510-0728",
      "search": "42\" x 30\" side wall vinyl sliding window framing kit new-42-side-wall-window-framing-kit windows container modification world 42 inch 42\" 42\" window frame sea can window framing kit sea can windows shipping container window frames shipping container window framing kit window frames window framing kit cmw-2k-510-0728 windows & door kits"
    },
    {
      "handle": "42-x-30-side-wall-window-frame-42-x-30-vinyl-window-bundle",
      "title": "42\" x 30\" Side Wall Window Frame + 42\" x 30\" Vinyl Window (BUNDLE)",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "windows",
      "vendor": "Container Modification World",
      "price": "$669.95",
      "status": "Available",
      "url": "/products/42-x-30-side-wall-window-frame-42-x-30-vinyl-window-bundle",
      "cmwUrl": "https://containermodificationworld.com/collections/windows-and-window-framing-kits",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/42_x_30_window_and_window_framing_kit_065fb40d-8f0e-46ca-ae1a-d8a37eebea56.png?v=1764622561",
      "imageAlt": "42\" x 30\" Side Wall Window Frame + 42\" x 30\" Vinyl Window (BUNDLE)",
      "summary": "NEW & IMPROVED DESIGN! Framing kits allow for quick and easy installation of any appropriately sized window with a vinyl nailing strip.",
      "sku": "CMW-2K-520-0780",
      "search": "42\" x 30\" side wall window frame + 42\" x 30\" vinyl window (bundle) 42-x-30-side-wall-window-frame-42-x-30-vinyl-window-bundle windows container modification world 42 inch 42 x30 42\" 42\" window frame container windows vinyl window vinyl windows window window frame window frames window framing kit windows cmw-2k-520-0780 windows & door kits"
    },
    {
      "handle": "42-vinyl-window",
      "title": "42\" x 30\" Vinyl Window For Shipping Container Side Wall",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "windows",
      "vendor": "Container Modification World",
      "price": "$274.95 - $669.95",
      "status": "Available",
      "url": "/products/42-vinyl-window",
      "cmwUrl": "https://containermodificationworld.com/42x30-side-wall-window",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/42_x_30_Vinyl_Sliding_Window_for_Shipping_Container_Optional_Frame_Bundle.png?v=1761754827",
      "imageAlt": "42\" x 30\" white vinyl sliding window with screen, designed for shipping container side wall installation.",
      "summary": "42\" x 30\" Vinyl Window For Shipping Container Side Wall Vinyl Window (WINDOW ONLY) & Window/Frame (BUNDLE) Available.",
      "sku": "CMW-2K-520-0783 | CMW-2K-520-0780",
      "search": "42\" x 30\" vinyl window for shipping container side wall 42-vinyl-window windows container modification world 48\" 48\" x 30\" window vinyl windows window windows cmw-2k-520-0783 | cmw-2k-520-0780 windows & door kits"
    },
    {
      "handle": "48-x-30-end-wall-framing-kit-48-x-30-vinyl-window-bundle",
      "title": "48\" x 30\" End Wall Framing Kit + 48\" x 30\" Vinyl Window (BUNDLE)",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "windows",
      "vendor": "Container Modification World",
      "price": "$714.95",
      "status": "Available",
      "url": "/products/48-x-30-end-wall-framing-kit-48-x-30-vinyl-window-bundle",
      "cmwUrl": "https://containermodificationworld.com/collections/windows-and-window-framing-kits",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/48x30windowandwindowframingkitbundle_d5dc78d6-8364-4892-b077-6e8701f75bbd.png?v=1762660198",
      "imageAlt": "48\" x 30\" End Wall Framing Kit + 48\" x 30\" Vinyl Window (BUNDLE)",
      "summary": "NEW & IMPROVED DESIGN! Framing kits allow for quick and easy installation of any appropriately sized window with a vinyl nailing strip.",
      "sku": "CMW-2K-520-0779",
      "search": "48\" x 30\" end wall framing kit + 48\" x 30\" vinyl window (bundle) 48-x-30-end-wall-framing-kit-48-x-30-vinyl-window-bundle windows container modification world 48 inch window frame 48\" 48\" window framing kit 48\" window kit 48\" x 30\" 48\" x 30\" window vinyl window vinyl windows window window frame window frames window framing kit windows cmw-2k-520-0779 windows & door kits"
    },
    {
      "handle": "new-48-end-wall-framing-kit",
      "title": "48\" x 30\" End Wall Vinyl Sliding Window Framing Kit",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "windows",
      "vendor": "Container Modification World",
      "price": "$414.95",
      "status": "Available",
      "url": "/products/new-48-end-wall-framing-kit",
      "cmwUrl": "https://containermodificationworld.com/collections/windows-and-window-framing-kits",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/48_inch_vinyl_window_for_shipping_container_FRONT.png?v=1767041782",
      "imageAlt": "48\" x 30\" End Wall Vinyl Sliding Window Framing Kit",
      "summary": "NEW & IMPROVED DESIGN! Framing kits allow for quick and easy installation of any appropriately sized window with a vinyl nailing strip.",
      "sku": "CMW-2K-510-0729",
      "search": "48\" x 30\" end wall vinyl sliding window framing kit new-48-end-wall-framing-kit windows container modification world 48 inch window frame 48\" window framing kit 48\" window kit 48\" x 30\" end sea can windows shipping container window framing kit vinyl window vinyl windows window window frame window framing kit windows cmw-2k-510-0729 windows & door kits"
    },
    {
      "handle": "48-vinyl-window",
      "title": "48\" x 30\" Vinyl Window For Shipping Container End Wall",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "windows",
      "vendor": "Container Modification World",
      "price": "$299.95 - $714.95",
      "status": "Available",
      "url": "/products/48-vinyl-window",
      "cmwUrl": "https://containermodificationworld.com/48x30-end-wall-window",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/48_e2a4964a-70be-4dc1-a7b6-1c7b0fb62a39.png?v=1759360134",
      "imageAlt": "48x30 inch horizontal sliding vinyl window for shipping container side walls, with screen and white frame – window only or frame bundle available",
      "summary": "48\" x 30\" Vinyl Window For Shipping Container Side Wall Vinyl Window (WINDOW ONLY) & Window/Frame (BUNDLE) Available.",
      "sku": "CMW-2K-520-0782 | CMW-2K-520-0779",
      "search": "48\" x 30\" vinyl window for shipping container end wall 48-vinyl-window windows container modification world container lock box shipping container window vinyl window window frame cmw-2k-520-0782 | cmw-2k-520-0779 windows & door kits"
    },
    {
      "handle": "new-32-or-36-fiberglass-composite-man-door-frame-bundle-slab-lever-hinges",
      "title": "Fiberglass / Composite Insulated Man Door & Frame",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "Man Door",
      "vendor": "Container Modification World",
      "price": "$1,250 - $1,350",
      "status": "Available",
      "url": "/products/new-32-or-36-fiberglass-composite-man-door-frame-bundle-slab-lever-hinges",
      "cmwUrl": "https://containermodificationworld.com/composite-man-door-and-frame",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/man-door-and-frame.png?v=1767040392",
      "imageAlt": "A white fiberglas/composite man door with a silver galvanized steel frame, featuring a door lever, sweep, and hinges.",
      "summary": "Gain Easy Access To Your Containers With Our Commercial-Grade Man Door Framing Kit Composite Door Slab is built for every climate!",
      "sku": "CMW-2K-110-1110 | CMW-2K-110-1109",
      "search": "fiberglass / composite insulated man door & frame new-32-or-36-fiberglass-composite-man-door-frame-bundle-slab-lever-hinges man door container modification world 32\" 36\" composite composite door man door man door for seacan man door framing kit man door slab cmw-2k-110-1110 | cmw-2k-110-1109 windows & door kits"
    },
    {
      "handle": "high-cube-end-wall",
      "title": "High Cube (9'6\") End Wall Galvanized RUD Framing Kit (7' x 7'3\")",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "Roll Up Door",
      "vendor": "Container Modification World",
      "price": "$800",
      "status": "Available",
      "url": "/products/high-cube-end-wall",
      "cmwUrl": "https://containermodificationworld.com/high-cube--side-wall-rud-framing-kits",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/ENDWALL_HC_90fec4fa-3ea7-49ed-bcbf-22be46fbd849.png?v=1767196157",
      "imageAlt": "Roll-up door installed on the end wall of a shipping container with galvanized steel framing kit, featuring horizontal panels and a center locking latch",
      "summary": "IMPORTANT: We only sell the framing kit. We have included the required information below to order the roll-up door itself Manufacture: Janus International Model: 650 Series US C...",
      "sku": "CMW-2K-300-0671",
      "search": "high cube (9'6\") end wall galvanized rud framing kit (7' x 7'3\") high-cube-end-wall roll up door container modification world garage door roll up door sea can roll up doors shipping container roll up doors cmw-2k-300-0671 windows & door kits"
    },
    {
      "handle": "high-cube-side-wall",
      "title": "High Cube (9'6\") Side Wall Roll Up Door Framing Kit",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "Roll Up Door",
      "vendor": "Container Modification World",
      "price": "$450 - $950",
      "status": "Available",
      "url": "/products/high-cube-side-wall",
      "cmwUrl": "https://containermodificationworld.com/high-cube--side-wall-rud-framing-kits",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Container-Roll-Up-Door-Framing-Kit.png?v=1767043098",
      "imageAlt": "Frontal view of a shipping container with a white Janus Model 650 roll-up door installed using a galvanized steel framing kit; only the framing kit is included—door must be purchased separately. Designed for sidewall installation with laser-cut symmetry, rain drip edge, and mounting hardware.",
      "summary": "IMPORTANT: We only sell the framing kit. We have included the required information below to order the roll-up door itself Manufacture: Janus International Model: 650 Series This...",
      "sku": "CMW-2K-300-0669 | CMW-2K-300-0673 | CMW-2K-300-0675 | CMW-2K-300-0677 | CMW-2A-300-0737",
      "search": "high cube (9'6\") side wall roll up door framing kit high-cube-side-wall roll up door container modification world garage door roll up door rud cmw-2k-300-0669 | cmw-2k-300-0673 | cmw-2k-300-0675 | cmw-2k-300-0677 | cmw-2a-300-0737 windows & door kits"
    },
    {
      "handle": "door-frame-only-slab-not-included",
      "title": "Man Door Frame Only (Slab Not Included)",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "Doors",
      "vendor": "Container Modification World",
      "price": "$850",
      "status": "Available",
      "url": "/products/door-frame-only-slab-not-included",
      "cmwUrl": "https://containermodificationworld.com/man-door-frame-only",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/new_32_x_80_man_door_amazon_main_5f13b62d-f478-4508-a5cf-f08360d8edb2.png?v=1767042616",
      "imageAlt": "Galvanized steel man door frame kit for shipping containers, shown with pre-installed door and hardware for easy container access.",
      "summary": "Gain easy access to your containers with our commercial-grade man door framing kit.",
      "sku": "CMW-2K-110-0006 | CMW-2K-110-1366",
      "search": "man door frame only (slab not included) door-frame-only-slab-not-included doors container modification world container door man door for seacan passage doors seacan door shipping container door cmw-2k-110-0006 | cmw-2k-110-1366 windows & door kits"
    },
    {
      "handle": "sliding-patio-door-frame",
      "title": "Sliding Patio Door Frame",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "Sliding Patio Door Frame For Shipping Container",
      "vendor": "Container Modification World",
      "price": "$749.95",
      "status": "Available",
      "url": "/products/sliding-patio-door-frame",
      "cmwUrl": "https://containermodificationworld.com/sliding-patio-door-frame",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/patio_frame_with_door.png?v=1767043193",
      "imageAlt": "Sliding patio door set including galvanized steel frame and glass door, designed for seamless integration with shipping container sidewalls",
      "summary": "Sliding Patio Door Frame for Shipping Containers Our Galvanized Steel Patio Door Frame is designed for seamless integration with shipping containers.",
      "sku": "CMW-2K-140-1532",
      "search": "sliding patio door frame sliding-patio-door-frame sliding patio door frame for shipping container container modification world patio patio doors sliding doors sliding patio doors cmw-2k-140-1532 windows & door kits"
    },
    {
      "handle": "standard-end-wall",
      "title": "Standard (8'6\") End Wall Framing Kit (7' x 6'8\")",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "Roll Up Door",
      "vendor": "Container Modification World",
      "price": "$775",
      "status": "Available",
      "url": "/products/standard-end-wall",
      "cmwUrl": "https://containermodificationworld.com/standard-end-wall-rud-framing-kit",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/ENDWALL_STRD_3b458f0e-dc03-43aa-ae72-abaeb9fef27e.png?v=1767196274",
      "imageAlt": "Roll-up door framing kit installed on shipping container sidewall, compatible with Janus Model 650 roll-up doors; framing only, door not included",
      "summary": "IMPORTANT: We only sell the framing kit. We have included the required information below to order the roll-up door itself Manufacture: Janus International ( https://www.janusint...",
      "sku": "CMW-2K-300-0663",
      "search": "standard (8'6\") end wall framing kit (7' x 6'8\") standard-end-wall roll up door container modification world end wall roll up door roll up door sea can roll up door shipping container garage door shipping container roll up door cmw-2k-300-0663 windows & door kits"
    },
    {
      "handle": "standard-side-wall",
      "title": "Standard (8'6\") Side Wall Roll Up Door Framing Kit",
      "category": "windows-door-kits",
      "categoryLabel": "Windows & Door Kits",
      "type": "Roll Up Door",
      "vendor": "Container Modification World",
      "price": "$450 - $950",
      "status": "Available",
      "url": "/products/standard-side-wall",
      "cmwUrl": "https://containermodificationworld.com/standard-side-wall-rud-kits",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/3drenderstandard.png?v=1767043148",
      "imageAlt": "High cube shipping container with a white roll-up door installed using a galvanized steel framing kit. The door is centered on the container sidewall, featuring a flush fit and a clean, weather-sealed finish. Framing kit includes all necessary hardware; roll-up door sold separately.",
      "summary": "IMPORTANT: We only sell the framing kit. We have included the required information below to order the roll-up door itself Manufacture: Janus International ( https://www.janusint...",
      "sku": "CMW-2K-300-0661 | CMW-2K-300-0665 | CMW-2K-300-0667 | CMW-2A-300-0737 | CMW-2K-310-1543",
      "search": "standard (8'6\") side wall roll up door framing kit standard-side-wall roll up door container modification world garage door roll up door rud cmw-2k-300-0661 | cmw-2k-300-0665 | cmw-2k-300-0667 | cmw-2a-300-0737 | cmw-2k-310-1543 windows & door kits"
    },
    {
      "handle": "heavy-duty-120v-ac-port-plugs-for-shipping-containers-sea-cans",
      "title": "Heavy Duty 120V AC PortPlugs™ for Shipping Containers/Sea Cans",
      "category": "electrical-solar",
      "categoryLabel": "Electrical / Solar",
      "type": "Electrical",
      "vendor": "Container Modification World",
      "price": "$39.95 - $74.95",
      "status": "Available",
      "url": "/products/heavy-duty-120v-ac-port-plugs-for-shipping-containers-sea-cans",
      "cmwUrl": "https://containermodificationworld.com/port-plugs",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/heavy-duty-120V-AC-port-plug-for-shipping-containers.jpg?v=1767207810",
      "imageAlt": "A black heavy duty 120V single port AC port plug with an integrated extension cord, designed for use with shipping containers.",
      "summary": "Quick and easy adaptive solution for supplying power to your shipping container when using an extension cord!",
      "sku": "CMW-1K-500-0521 | CMW-1K-500-0522 | CMW-1-500-0552",
      "search": "heavy duty 120v ac portplugs™ for shipping containers/sea cans heavy-duty-120v-ac-port-plugs-for-shipping-containers-sea-cans electrical container modification world 120v plug port plug cmw-1k-500-0521 | cmw-1k-500-0522 | cmw-1-500-0552 electrical / solar"
    },
    {
      "handle": "solar-panel-mounting-kit-roof",
      "title": "Solar Panel Mounting Kit (Roof)",
      "category": "electrical-solar",
      "categoryLabel": "Electrical / Solar",
      "type": "Solar",
      "vendor": "Container Modification World",
      "price": "$475",
      "status": "Available",
      "url": "/products/solar-panel-mounting-kit-roof",
      "cmwUrl": "https://containermodificationworld.com/products/solar-panel-mounting-kit-side-wall",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/solarpanelkitroof.png?v=1767823503",
      "imageAlt": "Solar Panel Mounting Kit (Roof)",
      "summary": "Solar Panel Mounting Kit (Roof) Turn your container roof into a power station - without welding, cutting, or complicated installs!",
      "sku": "CMW-4K-210-1409",
      "search": "solar panel mounting kit (roof) solar-panel-mounting-kit-roof solar container modification world solar brackets solar panel kit solar panel kit roof solar panel mounting solar panels cmw-4k-210-1409 electrical / solar"
    },
    {
      "handle": "solar-panel-mounting-kit-side-wall",
      "title": "Solar Panel Mounting Kit (Side Wall)",
      "category": "electrical-solar",
      "categoryLabel": "Electrical / Solar",
      "type": "Shipping Container Mod",
      "vendor": "Container Modification World",
      "price": "$475",
      "status": "Available",
      "url": "/products/solar-panel-mounting-kit-side-wall",
      "cmwUrl": "https://containermodificationworld.com/products/solar-panel-mounting-kit-roof",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Solar_Kit_Side_Wall_website_amazon.png?v=1767823490",
      "imageAlt": "Solar Panel Mounting Kit (Side Wall)",
      "summary": "Solar Panel Mounting Kit (Side Wall) Turn your container wall into a power station - without welding, cutting, or complicated installs!",
      "sku": "CMW-4K-210-1408",
      "search": "solar panel mounting kit (side wall) solar-panel-mounting-kit-side-wall shipping container mod container modification world solar brackets solar panel kit solar panel kit roof solar panel mounting solar panels solar power mount brackets containers cmw-4k-210-1408 electrical / solar"
    },
    {
      "handle": "12-small-utility-magnetic-basket-holds-up-to-35-lbs",
      "title": "12\" Small Utility Magnetic Basket - Holds up to 35 lbs",
      "category": "storage-shelving-racking",
      "categoryLabel": "Storage / Shelving / Racking",
      "type": "Magnetic Basket",
      "vendor": "Container Modification World",
      "price": "$59.95",
      "status": "Available",
      "url": "/products/12-small-utility-magnetic-basket-holds-up-to-35-lbs",
      "cmwUrl": "https://containermodificationworld.com/products/12-small-utility-magnetic-basket-holds-up-to-35-lbs",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/300054-C.png?v=1778010297",
      "imageAlt": "12\" Small Utility Magnetic Basket - Holds up to 35 lbs",
      "summary": "Small Utility Magnetic Basket – Holds Up to 35 lbs The Small Utility Magnetic Basket provides up to 35 lbs of shear holding power on steel surfaces, giving you compact wall-moun...",
      "sku": "300054-C",
      "search": "12\" small utility magnetic basket - holds up to 35 lbs 12-small-utility-magnetic-basket-holds-up-to-35-lbs magnetic basket container modification world basket 300054-c storage / shelving / racking"
    },
    {
      "handle": "18-large-utility-magnetic-basket-holds-up-to-35-lbs",
      "title": "18\" Large Utility Magnetic Basket - Holds up to 35 lbs",
      "category": "storage-shelving-racking",
      "categoryLabel": "Storage / Shelving / Racking",
      "type": "Magnetic Basket",
      "vendor": "Container Modification World",
      "price": "$64.95",
      "status": "Available",
      "url": "/products/18-large-utility-magnetic-basket-holds-up-to-35-lbs",
      "cmwUrl": "https://containermodificationworld.com/products/18-large-utility-magnetic-basket-holds-up-to-35-lbs",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/300050-C.png?v=1778007119",
      "imageAlt": "18\" Large Utility Magnetic Basket - Holds up to 35 lbs",
      "summary": "Large Utility Magnetic Basket - Holds Up to 35 lbs The Large Utility Magnetic Basket delivers heavy-duty steel wall storage for larger tools, supplies, and bulk items.",
      "sku": "300050-C",
      "search": "18\" large utility magnetic basket - holds up to 35 lbs 18-large-utility-magnetic-basket-holds-up-to-35-lbs magnetic basket container modification world 300050-c storage / shelving / racking"
    },
    {
      "handle": "ucm-shelving-bracket-1",
      "title": "18″ Galvanized Bolt-On Shelving Brackets (2 Pack)",
      "category": "storage-shelving-racking",
      "categoryLabel": "Storage / Shelving / Racking",
      "type": "Shelving Bracket",
      "vendor": "Container Modification World",
      "price": "$34.95",
      "status": "Available",
      "url": "/products/ucm-shelving-bracket-1",
      "cmwUrl": "https://containermodificationworld.com/18-inch-galv-bolt-on-shelving-brackets",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/18_-galvanized-bolt-on-shelving-brackets-2-pack.png?v=1767042116",
      "imageAlt": "Pair of 18-inch galvanized steel bolt-on shelving brackets for shipping containers, featuring multiple mounting holes for adjustable height and 350 lb load capacity.",
      "summary": "18″ Galvanized Bolt-On Shelving Brackets for Shipping Containers (2 Pack) Easily secures to strut with 1/2\" bolts and spring nuts.",
      "sku": "CMW-4K-310-0705",
      "search": "18″ galvanized bolt-on shelving brackets (2 pack) ucm-shelving-bracket-1 shelving bracket container modification world black shelving brackets glavanized brackets heavy duty shelving bracket shelving brackets for shipping containers shelving sea cans cmw-4k-310-0705 storage / shelving / racking"
    },
    {
      "handle": "2-5-midi-closed-magnetic-hook-holds-up-to-25-lbs",
      "title": "2.5\" MIDI Closed Magnetic Hook - Holds up to 25 lbs",
      "category": "storage-shelving-racking",
      "categoryLabel": "Storage / Shelving / Racking",
      "type": "Magnetic Hook",
      "vendor": "Container Modification World",
      "price": "$29.95",
      "status": "Available",
      "url": "/products/2-5-midi-closed-magnetic-hook-holds-up-to-25-lbs",
      "cmwUrl": "https://containermodificationworld.com/products/2-5-midi-closed-magnetic-hook",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/300007-C.png?v=1778010588",
      "imageAlt": "2.5\" MIDI Closed Magnetic Hook - Holds up to 25 lbs",
      "summary": "Compact Heavy-Duty Closed Magnetic Hook – Holds Up to 25 lbs The Gator Magnetics MIDI 2.5\" Closed Magnetic Hook delivers up to 25 lbs of shear holding power in a compact footprint.",
      "sku": "300007-C",
      "search": "2.5\" midi closed magnetic hook - holds up to 25 lbs 2-5-midi-closed-magnetic-hook-holds-up-to-25-lbs magnetic hook container modification world hook magnetic hook 300007-c storage / shelving / racking"
    },
    {
      "handle": "2-5-midi-open-magnetic-hook-holds-up-to-25-lbs",
      "title": "2.5\" MIDI Open Magnetic Hook - Holds up to 25 lbs",
      "category": "storage-shelving-racking",
      "categoryLabel": "Storage / Shelving / Racking",
      "type": "Magnetic Hook",
      "vendor": "Container Modification World",
      "price": "$29.95",
      "status": "Available",
      "url": "/products/2-5-midi-open-magnetic-hook-holds-up-to-25-lbs",
      "cmwUrl": "https://containermodificationworld.com/products/2-5-midi-open-magnetic-hook",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/300008-C.png?v=1778010559",
      "imageAlt": "2.5\" MIDI Open Magnetic Hook - Holds up to 25 lbs",
      "summary": "Compact Heavy-Duty Open Magnetic Hook - Holds Up to 25 lbs The Gator Magnetics MIDI 2.5\" Open Magnetic Hook delivers up to 25 lbs of shear holding power in a compact footprint.",
      "sku": "300008-C",
      "search": "2.5\" midi open magnetic hook - holds up to 25 lbs 2-5-midi-open-magnetic-hook-holds-up-to-25-lbs magnetic hook container modification world hook magnetic hook 300008-c storage / shelving / racking"
    },
    {
      "handle": "2-5-midi-open-magnetic-hook-3-pack",
      "title": "2.5\" MIDI Open Magnetic Hook - Holds up to 25 lbs (3-Pack)",
      "category": "storage-shelving-racking",
      "categoryLabel": "Storage / Shelving / Racking",
      "type": "Magnetic Hook",
      "vendor": "Container Modification World",
      "price": "$77.95",
      "status": "Available",
      "url": "/products/2-5-midi-open-magnetic-hook-3-pack",
      "cmwUrl": "https://containermodificationworld.com/products/2-5-midi-open-magnetic-hook-3-pack",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/300008-C_-_3-pack.png?v=1780669541",
      "imageAlt": "2.5\" MIDI Open Magnetic Hook - Holds up to 25 lbs (3-Pack)",
      "summary": "Compact Heavy-Duty Open Magnetic Hook - Holds Up to 25 lbs The Gator Magnetics MIDI 2.5\" Open Magnetic Hook delivers up to 25 lbs of shear holding power in a compact footprint.",
      "sku": "CMW-4K-330-2299",
      "search": "2.5\" midi open magnetic hook - holds up to 25 lbs (3-pack) 2-5-midi-open-magnetic-hook-3-pack magnetic hook container modification world hook magnetic hook cmw-4k-330-2299 storage / shelving / racking"
    },
    {
      "handle": "3-mega-closed-magnetic-hook-holds-up-to-45-lbs",
      "title": "3\" MEGA Closed Magnetic Hook - Holds up to 45 lbs",
      "category": "storage-shelving-racking",
      "categoryLabel": "Storage / Shelving / Racking",
      "type": "Magnetic Hook",
      "vendor": "Container Modification World",
      "price": "$34.95",
      "status": "Available",
      "url": "/products/3-mega-closed-magnetic-hook-holds-up-to-45-lbs",
      "cmwUrl": "https://containermodificationworld.com/products/3-mega-closed-magnetic-hook",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/300034-C.png?v=1778010489",
      "imageAlt": "3\" MEGA Closed Magnetic Hook - Holds up to 45 lbs",
      "summary": "Compact Heavy-Duty Closed Magnetic Hook - Holds Up to 45 lbs The Gator Magnetics MEGA 3\" Closed Magnetic Hook delivers up to 45 lbs of shear holding power in a compact footprint.",
      "sku": "300034-C",
      "search": "3\" mega closed magnetic hook - holds up to 45 lbs 3-mega-closed-magnetic-hook-holds-up-to-45-lbs magnetic hook container modification world hook magnetic hook 300034-c storage / shelving / racking"
    },
    {
      "handle": "3-mega-open-magnetic-hook-holds-up-to-45-lbs",
      "title": "3\" MEGA Open Magnetic Hook - Holds up to 45 lbs",
      "category": "storage-shelving-racking",
      "categoryLabel": "Storage / Shelving / Racking",
      "type": "Magnetic Hook",
      "vendor": "Container Modification World",
      "price": "$34.95",
      "status": "Available",
      "url": "/products/3-mega-open-magnetic-hook-holds-up-to-45-lbs",
      "cmwUrl": "https://containermodificationworld.com/products/3-mega-open-magnetic-hook",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/300033-C.png?v=1778010455",
      "imageAlt": "3\" MEGA Open Magnetic Hook - Holds up to 45 lbs",
      "summary": "Compact Heavy-Duty Open Magnetic Hook - Holds Up to 45 lbs The Gator Magnetics MEGA 3\" Open Magnetic Hook delivers up to 45 lbs of shear holding power in a compact footprint.",
      "sku": "300033-C",
      "search": "3\" mega open magnetic hook - holds up to 45 lbs 3-mega-open-magnetic-hook-holds-up-to-45-lbs magnetic hook container modification world 300033-c storage / shelving / racking"
    },
    {
      "handle": "4-5-mega-closed-magnetic-hook-holds-up-to-45-lbs",
      "title": "4.5\" MEGA Closed Magnetic Hook - Holds up to 45 lbs",
      "category": "storage-shelving-racking",
      "categoryLabel": "Storage / Shelving / Racking",
      "type": "Magnetic Hook",
      "vendor": "Container Modification World",
      "price": "$34.95",
      "status": "Available",
      "url": "/products/4-5-mega-closed-magnetic-hook-holds-up-to-45-lbs",
      "cmwUrl": "https://containermodificationworld.com/products/4-5-mega-closed-magnetic-hook",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/300035-C.png?v=1778010426",
      "imageAlt": "4.5\" MEGA Closed Magnetic Hook - Holds up to 45 lbs",
      "summary": "Heavy-Duty Closed Magnetic Hook - Holds Up to 45 lbs Take on your toughest organization challenges with the Gator Magnetics MEGA 4.5\" Closed Magnetic Hook.",
      "sku": "300035-C",
      "search": "4.5\" mega closed magnetic hook - holds up to 45 lbs 4-5-mega-closed-magnetic-hook-holds-up-to-45-lbs magnetic hook container modification world hook magnetic hook 300035-c storage / shelving / racking"
    },
    {
      "handle": "4-midi-open-magnetic-hook-holds-up-to-25-lbs",
      "title": "4\" MIDI Open Magnetic Hook - Holds up to 25 lbs",
      "category": "storage-shelving-racking",
      "categoryLabel": "Storage / Shelving / Racking",
      "type": "Magnetic Hook",
      "vendor": "Container Modification World",
      "price": "$29.95",
      "status": "Available",
      "url": "/products/4-midi-open-magnetic-hook-holds-up-to-25-lbs",
      "cmwUrl": "https://containermodificationworld.com/products/4-midi-open-magnetic-hook",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/3000013-C.png?v=1778010529",
      "imageAlt": "4\" MIDI Open Magnetic Hook - Holds up to 25 lbs",
      "summary": "Heavy-Duty Open Magnetic Hook - Holds Up to 25 lbs Take on demanding organization projects with the Gator Magnetics MIDI 4\" Open Magnetic Hook.",
      "sku": "300013-C",
      "search": "4\" midi open magnetic hook - holds up to 25 lbs 4-midi-open-magnetic-hook-holds-up-to-25-lbs magnetic hook container modification world hook magnetic hook 300013-c storage / shelving / racking"
    },
    {
      "handle": "ucm-shelving-bracket",
      "title": "CSM™ Pipe Rack",
      "category": "storage-shelving-racking",
      "categoryLabel": "Storage / Shelving / Racking",
      "type": "Pipe Rack",
      "vendor": "Container Modification World",
      "price": "$30",
      "status": "Available",
      "url": "/products/ucm-shelving-bracket",
      "cmwUrl": "https://containermodificationworld.com/products/ucm-shelving-bracket",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/single_pipe_rack_amazon.png?v=1767043027",
      "imageAlt": "CSM pipe rack bracket for shipping container strut systems — galvanized steel with slotted mounting plate, available in 16\", 20\", and 24\" lengths.",
      "summary": "The CSM™ Pipe Rack is designed to secure to struts with 3/8\" bolts and spring nuts.",
      "sku": "CMW-4K-310-0366 | CMW-4K-310-0364 | CMW-4K-310-0362",
      "search": "csm™ pipe rack ucm-shelving-bracket pipe rack container modification world container modification pipe rack container shelving exterior pipe rack interior pipe rack pipe rack sea can pipe rack shipping container pipe rack cmw-4k-310-0366 | cmw-4k-310-0364 | cmw-4k-310-0362 storage / shelving / racking"
    },
    {
      "handle": "insta-3210-shipping-container-shelving-brackets-3-pack",
      "title": "Instant Shipping Container Shelving Brackets (3 Pack)",
      "category": "storage-shelving-racking",
      "categoryLabel": "Storage / Shelving / Racking",
      "type": "Shelving Bracket",
      "vendor": "Container Modification World",
      "price": "$299.95",
      "status": "Available",
      "url": "/products/insta-3210-shipping-container-shelving-brackets-3-pack",
      "cmwUrl": "https://containermodificationworld.com/instant-shelving-brackets-3pk-canada",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Instant-shipping-container-shelving-brackets.png?v=1767214159",
      "imageAlt": "A set of two metal instant shelving brackets designed for use with shipping containers, featuring three shelves made from wooden planks.",
      "summary": "Maximize your space and keep your items organized inside the can. These Shelving Brackets are quick and easy to install.",
      "sku": "CMW-4K-310-0963",
      "search": "instant shipping container shelving brackets (3 pack) insta-3210-shipping-container-shelving-brackets-3-pack shelving bracket container modification world insta shelving brackets instant shelving sea can shelving shipping container shelving brackets cmw-4k-310-0963 storage / shelving / racking"
    },
    {
      "handle": "18000-lb-capacity-shipping-container-sea-can-forklift-ramp",
      "title": "18000 lb Capacity Steel Forklift Ramp",
      "category": "access-ramps-stairs",
      "categoryLabel": "Access / Ramps / Stairs",
      "type": "Container Ramp",
      "vendor": "Container Modification World",
      "price": "$1,725",
      "status": "Available",
      "url": "/products/18000-lb-capacity-shipping-container-sea-can-forklift-ramp",
      "cmwUrl": "https://containermodificationworld.com/steel-forklift-ramp",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Heavy-Duty_Steel-Container-Ramp_18_000-lb-Capacity.jpg?v=1767042815",
      "imageAlt": "Heavy-duty steel ramp for shipping containers, featuring reinforced rib construction and 18,000 lb capacity",
      "summary": "Perfect for Standard or High Cube size containers. This heavy-duty ramp is made from 5mm checker plate steel on top and double reinforced steel rib construction underneath.",
      "sku": "CMW-5K-410-0739",
      "search": "18000 lb capacity steel forklift ramp 18000-lb-capacity-shipping-container-sea-can-forklift-ramp container ramp container modification world container ramp forklift ramp ramp sea can ramp sea can ramps cmw-5k-410-0739 access / ramps / stairs"
    },
    {
      "handle": "heavy-duty-rubber-container-entry-ramps-2-pack",
      "title": "Heavy Duty Rubber Shipping Container Ramps (2 Pack)",
      "category": "access-ramps-stairs",
      "categoryLabel": "Access / Ramps / Stairs",
      "type": "Container Ramp",
      "vendor": "Container Modification World",
      "price": "$249.95",
      "status": "Available",
      "url": "/products/heavy-duty-rubber-container-entry-ramps-2-pack",
      "cmwUrl": "https://containermodificationworld.com/heavy-duty-container-ramps",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/MainRubberRamp2Pack.png?v=1772566567",
      "imageAlt": "Heavy Duty Rubber Shipping Container Ramps (2 Pack)",
      "summary": "Heavy Duty Rubber Container Entry Ramps (2 Pack) Key Features Perfect for shipping container access Ideal for driving vehicles, ATVs, UTVs, lawn & garden tractors, carts, cars,...",
      "sku": "CMW-5K-410-2109",
      "search": "heavy duty rubber shipping container ramps (2 pack) heavy-duty-rubber-container-entry-ramps-2-pack container ramp container modification world curb ramps plastic ramps ramps rubber ramps sea can ramps cmw-5k-410-2109 access / ramps / stairs"
    },
    {
      "handle": "rubber-ramps-for-shipping-containers-sea-cans-industrial-strength-2-pack",
      "title": "Rubber Ramps (2 Pack)",
      "category": "access-ramps-stairs",
      "categoryLabel": "Access / Ramps / Stairs",
      "type": "Container Ramp",
      "vendor": "Container Modification World",
      "price": "$199.95",
      "status": "Available",
      "url": "/products/rubber-ramps-for-shipping-containers-sea-cans-industrial-strength-2-pack",
      "cmwUrl": "https://containermodificationworld.com/products/rubber-ramps-for-shipping-containers-sea-cans-industrial-strength-2-pack",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/2shippingcontainerrubberrampsmain.png?v=1767043160",
      "imageAlt": "Heavy-Duty Container Access Ramps – High-Density Rubber Ramps for Shipping Containers, 2-Pack, 500mm x 500mm x 140mm, 1000kg Capacity, Vehicle and ATV Compatible",
      "summary": "Great for driving into your container with vehicles, ATVs, and garden tractors. Made of high-density industrial-grade rubber/plastic High strength - super durable!",
      "sku": "CMW-5K-410-0422",
      "search": "rubber ramps (2 pack) rubber-ramps-for-shipping-containers-sea-cans-industrial-strength-2-pack container ramp container modification world container ramp curb ramps plastic ramps ramp rubber ramps sea can ramp sea can ramps cmw-5k-410-0422 access / ramps / stairs"
    },
    {
      "handle": "alignment-cones",
      "title": "Alignment Cone Kit (4 Pack)",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Stacking Hardware",
      "vendor": "Container Modification World",
      "price": "$399",
      "status": "Available",
      "url": "/products/alignment-cones",
      "cmwUrl": "https://containermodificationworld.com/products/alignment-cones",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/kit_includes_4_alignment_cones_e36e36df-8947-4f6f-a054-7b360dd11692.png?v=1767802283",
      "imageAlt": "Alignment Cone Kit (4 Pack)",
      "summary": "Alignment Cone Kit (4 Pack)",
      "sku": "CMW-5K-320-1762",
      "search": "alignment cone kit (4 pack) alignment-cones stacking hardware container modification world cmw-5k-320-1762 hardware / components"
    },
    {
      "handle": "bolt-on-d-ring-lashing-points-for-shipping-containers",
      "title": "Bolt On D-Ring Lashing Points for Shipping Containers",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Tie Downs",
      "vendor": "Container Modification World",
      "price": "$74.95",
      "status": "Available",
      "url": "/products/bolt-on-d-ring-lashing-points-for-shipping-containers",
      "cmwUrl": "https://containermodificationworld.com/bolt-on-d-ring-lashing-points",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/bolt-on-d-ring-lashing-points.png?v=1767042063",
      "imageAlt": "Three black bolt-on D-ring lashing points for shipping containers with included screws.",
      "summary": "Universal Bolt-On D-Ring Lashing Points for Shipping Containers Designed for containers that do not have a D-Rings welded inside.",
      "sku": "CMW-4K-330-0649",
      "search": "bolt on d-ring lashing points for shipping containers bolt-on-d-ring-lashing-points-for-shipping-containers tie downs container modification world shipping container d rings cmw-4k-330-0649 hardware / components"
    },
    {
      "handle": "bridge-fitting",
      "title": "Bridge Fitting Clamp - Bolt/Twist/Screw Style (2 Pack)",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Bridge Fitting",
      "vendor": "Container Modification World",
      "price": "$199.95",
      "status": "Available",
      "url": "/products/bridge-fitting",
      "cmwUrl": "https://containermodificationworld.com/bridge-fittings",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/main-amazon-bridge-fitting.jpg?v=1767042142",
      "imageAlt": "Pair of heavy-duty container bridge fittings made of hot-dip galvanized drop-forged steel, designed to securely connect ISO shipping containers side to side or end to end via corner castings. Rated for a 10-ton load capacity.",
      "summary": "Safely connect shipping containers to each other. Designed to safely and securely connect empty or loaded shipping containers horizontally and are made to fit into container cor...",
      "sku": "CMW-5K-320-0356",
      "search": "bridge fitting clamp - bolt/twist/screw style (2 pack) bridge-fitting bridge fitting container modification world bolt style bridge fitting clamp galvanized join containers together two iso shipping containers together cmw-5k-320-0356 hardware / components"
    },
    {
      "handle": "shipping-container-door-flashing-kit",
      "title": "Container Door Flashing Kit (Standard & High Cube)",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Door Flashing Kit",
      "vendor": "Container Modification World",
      "price": "$475 - $490",
      "status": "Available",
      "url": "/products/shipping-container-door-flashing-kit",
      "cmwUrl": "https://containermodificationworld.com/door-flashing-kits",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/shipping-container-door-flashing-kit.png?v=1767203811",
      "imageAlt": "Top-down view of a galvanized steel container door flashing kit installed on a double shipping container door, with clean trim and visible included mounting hardware for a finished interior framing edge",
      "summary": "Our container door flashing kit provides a clean and durable finish to shipping container doors that are required to remain in use after framing, insulating, and lining the inte...",
      "sku": "CMW-4K-410-0651 | CMW-4K-410-0650",
      "search": "container door flashing kit (standard & high cube) shipping-container-door-flashing-kit door flashing kit container modification world container door spray foam door flashing kit sea can door insulation kit seacan door flashing kit shipping container door framing cmw-4k-410-0651 | cmw-4k-410-0650 hardware / components"
    },
    {
      "handle": "container-pads",
      "title": "Container Pads (4 Pack)",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Container Pads",
      "vendor": "Container Modification World",
      "price": "$199.95",
      "status": "Available",
      "url": "/products/container-pads",
      "cmwUrl": "https://containermodificationworld.com/container-pads",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/4-pack-shipping-container-pads.png?v=1767042413",
      "imageAlt": "Heavy-duty container corner pad dispersing weight to protect concrete and paved surfaces",
      "summary": "Disperses weight of corner castings more evenly - 7x more surface area! Ideal for protecting concrete, paved, and other surfaces Prevents your container from sinking into soil W...",
      "sku": "CMW-5K-200-1016",
      "search": "container pads (4 pack) container-pads container pads container modification world base container pads level levelling padding sea can pads shipping container foundation cmw-5k-200-1016 hardware / components"
    },
    {
      "handle": "container-shoes-4-pk",
      "title": "Container Shoes (4 PK)",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Container Pads",
      "vendor": "Container Modification World",
      "price": "$199.95",
      "status": "Available",
      "url": "/products/container-shoes-4-pk",
      "cmwUrl": "https://containermodificationworld.com/products/container-shoes-4-pk",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Container_Shoes_Heavy-Duty_Surface-Protection-Pads-for-Shipping-Containers-set-of-four.png?v=1767042449",
      "imageAlt": "Black high-density polyethylene container shoes designed to protect driveways and job sites when placing or moving standard ISO shipping containers",
      "summary": "Tired of cracked driveways and damaged job sites? Our Container Shoes are the ultimate solution to protect surfaces when moving, towing, or placing shipping containers.",
      "sku": "CMW-5K-200-1245",
      "search": "container shoes (4 pk) container-shoes-4-pk container pads container modification world foundation padding shipping container foundation shoes cmw-5k-200-1245 hardware / components"
    },
    {
      "handle": "door-gasket-seal-for-shipping-containers-and-sea-cans",
      "title": "Door Gasket Seal",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Door Parts",
      "vendor": "Container Modification World",
      "price": "$299.95 - $324.95",
      "status": "Available",
      "url": "/products/door-gasket-seal-for-shipping-containers-and-sea-cans",
      "cmwUrl": "https://containermodificationworld.com/door-gasket-seals",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/heavy-duty-rubber-door-seal-gasket-for-standard-or-high-cube-shipping-containers.jpg?v=1761753597",
      "imageAlt": "Heavy-duty rubber door seal gasket for standard or high cube 8' x 8'6\" and 8' x 9'6\" shipping containers or sea cans, easy to install for weatherproofing container doors.",
      "summary": "Built Tough Easy to Install Standard Fits 8′ x 8’6″ Shipping Container/Sea Can Doors High Cube Fits 8′ x 9’6″ Shipping Container/Sea Can Doors",
      "sku": "CMW-2K-000-0708 | CMW-2K-000-0709",
      "search": "door gasket seal door-gasket-seal-for-shipping-containers-and-sea-cans door parts container modification world cmw-2k-000-0708 | cmw-2k-000-0709 hardware / components"
    },
    {
      "handle": "dovetail-deck-mount-twist-lock-for-shipping-container-2-pack",
      "title": "Dovetail Deck Mount Twist Locks",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Twist Lock",
      "vendor": "Container Modification World",
      "price": "$199.95",
      "status": "Available",
      "url": "/products/dovetail-deck-mount-twist-lock-for-shipping-container-2-pack",
      "cmwUrl": "https://containermodificationworld.com/deck-mount-twist-lock",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/dovetail-deck-mount-twist-lock.png?v=1762969701",
      "imageAlt": "A pair of silver-colored dovetail deck mount twist locks with a flat base design.",
      "summary": "These Deck Mount Twist Locks have a flat base, which is generally used to weld directly onto steel decks on ships and secure the containers during transport.",
      "sku": "CMW-5K-310-0727",
      "search": "dovetail deck mount twist locks dovetail-deck-mount-twist-lock-for-shipping-container-2-pack twist lock container modification world dovetail deck mount twist lock shipping container twist lock cmw-5k-310-0727 hardware / components"
    },
    {
      "handle": "fork-pocket-covers-for-spray-foam",
      "title": "Fork Pocket Covers For Spray Foaming",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Envelope",
      "vendor": "Container Modification World",
      "price": "$179.95 - $279.95",
      "status": "Available",
      "url": "/products/fork-pocket-covers-for-spray-foam",
      "cmwUrl": "https://containermodificationworld.com/products/fork-pocket-covers-for-spray-foam",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Fork-pocket-Covers_Spray-Foam-Containment-Kits-for-Shipping-Containers_14a3faf8-d0e6-44a1-b848-83a1de7cc318.jpg?v=1767042742",
      "imageAlt": "Close-up of steel fork pocket covers for shipping containers, designed to block spray foam from escaping through forklift holes",
      "summary": "SEAL YOUR FORK POCKETS BEFORE SPRAY FOAMING! A major problem many shipping container owners experience when applying spray foam to the undercarriage of a shipping container is t...",
      "sku": "CMW-4K-500-0389 | CMW-4K-500-0391 | CMW-4K-500-0390",
      "search": "fork pocket covers for spray foaming fork-pocket-covers-for-spray-foam envelope container modification world block pigeon container door spray foam keep rodents out of container mice container mice sea can mice seacan pigeon sea can rats container rats sea can rodent proof shipping container spray spray foam insulation cmw-4k-500-0389 | cmw-4k-500-0391 | cmw-4k-500-0390 hardware / components"
    },
    {
      "handle": "g80-sea-crane-hooks-lifting-hooks-for-shipping-containers-sea-cans-cargo",
      "title": "G80 SEA Crane Hooks / Lifting Hooks",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Lifting Hardware",
      "vendor": "Container Modification World",
      "price": "$124.95",
      "status": "Available",
      "url": "/products/g80-sea-crane-hooks-lifting-hooks-for-shipping-containers-sea-cans-cargo",
      "cmwUrl": "https://containermodificationworld.com/lifting-hooks",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/straight-lift-shipping-container-crane-hook.png?v=1767042508",
      "imageAlt": "Yellow Grade 80 shipping container lifting hook with eyelet, designed for secure attachment to container corner castings; rated for 28,000 lb working load limit.",
      "summary": "The process of lifting and maneuvering shipping containers can be challenging without the right equipment.",
      "sku": "CMW-5K-200-0713 | CMW-5K-200-0714 | CMW-5K-200-0715",
      "search": "g80 sea crane hooks / lifting hooks g80-sea-crane-hooks-lifting-hooks-for-shipping-containers-sea-cans-cargo lifting hardware container modification world container crane hooks container hooks container sling hooks lifting lugs sea cans shipping container lift hooks shipping containers cmw-5k-200-0713 | cmw-5k-200-0714 | cmw-5k-200-0715 hardware / components"
    },
    {
      "handle": "iso-1611-corner-casting-kits",
      "title": "ISO 1161 Corner Casting Kits",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Corner Castings",
      "vendor": "Container Modification World",
      "price": "$249.95 - $699.95",
      "status": "Available",
      "url": "/products/iso-1611-corner-casting-kits",
      "cmwUrl": "https://containermodificationworld.com/corner-castings",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/corner_castings_for_shipping_containers_Main.png?v=1767197817",
      "imageAlt": "ISO 1161 steel corner castings for shipping containers, showing four block fittings used to connect and lift containers via crane or transport systems. Compatible with top left, top right, bottom left, and bottom right positions",
      "summary": "Sea Can Container Corner Castings or Corner Fittings are the carbon steel corners of an ISO 1161 shipping container.",
      "sku": "CMW-5K-300-0371 | CMW-5K-300-0372 | CMW-5K-300-0373 | CMW-5K-300-0374 | CMW-5K-300-0375",
      "search": "iso 1161 corner casting kits iso-1611-corner-casting-kits corner castings container modification world container corner castings corner casting sea can corner casting seacan corner castings shipping container corner casting cmw-5k-300-0371 | cmw-5k-300-0372 | cmw-5k-300-0373 | cmw-5k-300-0374 | cmw-5k-300-0375 hardware / components"
    },
    {
      "handle": "kick-n-close-kick-plate-for-shipping-containers-sea-cans-protects-your-door-seals",
      "title": "Kick 'N' Close Kick Plate (Protects Your Door Seals)",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Door Parts",
      "vendor": "Container Modification World",
      "price": "$49.95",
      "status": "Available",
      "url": "/products/kick-n-close-kick-plate-for-shipping-containers-sea-cans-protects-your-door-seals",
      "cmwUrl": "https://containermodificationworld.com/kick-plate",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Kick-_N_-close-kick-plate.png?v=1767209437",
      "imageAlt": "A black powder coated steel kick plate with the text 'Container Modification World' on it, designed to protect door seals.",
      "summary": "Extends the life span of your Rubber Door Seals Comes with 3 square profile Stainless Steel Carriage Bolts and Nuts Black powder-coated steel Installs in minutes!",
      "sku": "CMW-5K-300-0712",
      "search": "kick 'n' close kick plate (protects your door seals) kick-n-close-kick-plate-for-shipping-containers-sea-cans-protects-your-door-seals door parts container modification world door plate kick plate shipping container kick plate cmw-5k-300-0712 hardware / components"
    },
    {
      "handle": "long-bridge-fitting-clamp-bolt-twist-screw-style-4-pack",
      "title": "Long Bridge Fitting Clamp - Bolt/Twist/Screw Style (4 Pack)",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Stacking Hardware",
      "vendor": "Container Modification World",
      "price": "$499.95",
      "status": "Available",
      "url": "/products/long-bridge-fitting-clamp-bolt-twist-screw-style-4-pack",
      "cmwUrl": "https://containermodificationworld.com/long-bridge-fittings",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/LongBridgeFittings.png?v=1764791658",
      "imageAlt": "Long Bridge Fitting Clamp - Bolt/Twist/Screw Style (4 Pack)",
      "summary": "Safely connect shipping containers to each other. Designed to safely and securely connect empty or loaded shipping containers horizontally and are made to fit into container cor...",
      "sku": "CMW-5K-320-1763",
      "search": "long bridge fitting clamp - bolt/twist/screw style (4 pack) long-bridge-fitting-clamp-bolt-twist-screw-style-4-pack stacking hardware container modification world cmw-5k-320-1763 hardware / components"
    },
    {
      "handle": "pest-plugs",
      "title": "PestPlug™ Fork Pocket Covers",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Pest Control",
      "vendor": "Container Modification World",
      "price": "$179.95 - $279.95",
      "status": "Available",
      "url": "/products/pest-plugs",
      "cmwUrl": "https://containermodificationworld.com/products/pest-plugs",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Fork-pocket-Covers_Spray-Foam-Containment-Kits-for-Shipping-Containers.jpg?v=1762660167",
      "imageAlt": "Close-up of steel fork pocket covers for shipping containers, designed to block spray foam from escaping through forklift holes",
      "summary": "KEEP OUT ANIMALS & BIRDS! A major problem many shipping container owners experience during the winter is rodents sneaking in underneath through the forklift pockets, or having m...",
      "sku": "CMW-4K-500-0389 | CMW-4K-500-0391 | CMW-4K-500-0390",
      "search": "pestplug™ fork pocket covers pest-plugs pest control container modification world block pigeon keep rodents out of container mice container mice sea can mice seacan pigeon sea can rats container rats sea can rodent proof shipping container cmw-4k-500-0389 | cmw-4k-500-0391 | cmw-4k-500-0390 hardware / components"
    },
    {
      "handle": "quick-attach-skid",
      "title": "Quick Attach Skid",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Skids",
      "vendor": "Container Modification World",
      "price": "$1,495.95",
      "status": "Available",
      "url": "/products/quick-attach-skid",
      "cmwUrl": "https://containermodificationworld.com/quick-attach-skid",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/quick-attach-skid.png?v=1761929544",
      "imageAlt": "Pair of heavy-duty yellow shipping container lifting lugs with screw-lock mechanism, designed for secure top-corner lifting during container transport and rigging",
      "summary": "Technical diagram of the 5340 Universal Lock Box with dimensions labeled (5.5\" wide, 4.5\" tall, 2.25\" deep, 3/16\" thick), designed for shipping containers and semi van trailers.",
      "sku": "CMW-5K-220-0471",
      "search": "quick attach skid quick-attach-skid skids container modification world attach wench to sea can oilpatch quick attach skids wench truck cmw-5k-220-0471 hardware / components"
    },
    {
      "handle": "quick-attach-tie-downs-for-anchoring-bolting-shipping-container-to-cement-rock-floor-2-pack",
      "title": "Quick Attach Tie Downs For Anchoring/Bolting Shipping Container To Cement/Rock Floor (2 Pack)",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Tie Downs",
      "vendor": "Container Modification World",
      "price": "$249.95",
      "status": "Available",
      "url": "/products/quick-attach-tie-downs-for-anchoring-bolting-shipping-container-to-cement-rock-floor-2-pack",
      "cmwUrl": "https://containermodificationworld.com/quick-attach-tie-downs",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/galv-shipping-container-tie-downs.png?v=1763134705",
      "imageAlt": "Pair of galvanized steel Quick Attach Tie Downs designed to fit ISO 1161 corner castings, used for anchoring shipping containers to concrete, rock, or metal surfaces.",
      "summary": "Quick Attach Tie Downs fit ISO 1611 corner castings and provide an anchor point to bolt into cement, rock, or metal ground surfaces to keep your shipping container stabilized.",
      "sku": "CMW-5K-330-0936",
      "search": "quick attach tie downs for anchoring/bolting shipping container to cement/rock floor (2 pack) quick-attach-tie-downs-for-anchoring-bolting-shipping-container-to-cement-rock-floor-2-pack tie downs container modification world container cemement anchor container tie downs quick attach tie downs shipping container anchors cmw-5k-330-0936 hardware / components"
    },
    {
      "handle": "quick-patch-repair-patch-for-shipping-containers-sea-cans",
      "title": "Quick Patch - Repair Patch for Shipping Containers/Sea Cans",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Repair Parts",
      "vendor": "Container Modification World",
      "price": "$39.95",
      "status": "Available",
      "url": "/products/quick-patch-repair-patch-for-shipping-containers-sea-cans",
      "cmwUrl": "https://containermodificationworld.com/products/quick-patch-repair-patch-for-shipping-containers-sea-cans",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/quick-patch.png?v=1767211146",
      "imageAlt": "Packaged repair patch in a clear plastic bag with a yellow label showing the product and its uses on shipping containers and sea cans.",
      "summary": "This UV light-activated fiberglass-reinforced self-adhesive repair patch is perfect for shipping containers/sea cans!",
      "sku": "CMW-7-300-0678",
      "search": "quick patch - repair patch for shipping containers/sea cans quick-patch-repair-patch-for-shipping-containers-sea-cans repair parts container modification world repair patch sea can wall repair shipping container wall repair wall repair cmw-7-300-0678 hardware / components"
    },
    {
      "handle": "container-jacker",
      "title": "Twist 'n' Jack (TNJ™) Container Lifter",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Moving Equipment",
      "vendor": "Container Modification World",
      "price": "$279.95",
      "status": "Available",
      "url": "/products/container-jacker",
      "cmwUrl": "https://containermodificationworld.com/twist-n-jack",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/twist-n-jack-for-shipping-containers.png?v=1767219952",
      "imageAlt": "Yellow steel container jacking tool with built-in handle and curved support arms, branded with \"TNJ\" logo—designed for leveling shipping containers using a bottle jack.",
      "summary": "Doors not working properly? 99% chance is because your container isn't level. This tool will allow you to easily jack and level your container using an appropriately sized bottl...",
      "sku": "CMW-5K-210-0550",
      "search": "twist 'n' jack (tnj™) container lifter container-jacker moving equipment container modification world cmw-5k-210-0550 hardware / components"
    },
    {
      "handle": "twist-locks",
      "title": "Twist Lock Stacking Pin for Shipping Containers (2 pack)",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Twist Lock",
      "vendor": "Container Modification World",
      "price": "$199.95",
      "status": "Available",
      "url": "/products/twist-locks",
      "cmwUrl": "https://containermodificationworld.com/products/twist-locks",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Twist-Lock-stacking-pin-2-pack.png?v=1763061617",
      "imageAlt": "Heavy-duty shipping container twist locks for stacking containers securely; galvanized steel construction with locking handle—sold in pairs, requires 4 per container.",
      "summary": "Used to safely secure containers when stacked on top of each other. Simple 90-degree turn to lock in place Requires 4 per container",
      "sku": "CMW-5K-310-0723",
      "search": "twist lock stacking pin for shipping containers (2 pack) twist-locks twist lock container modification world container bridge fittings container stacking pin stacking twist lock cmw-5k-310-0723 hardware / components"
    },
    {
      "handle": "wall-flashing-kit-1",
      "title": "Wall Flashing Kit (Standard & High Cube)",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Flashing",
      "vendor": "Container Modification World",
      "price": "$300 - $315",
      "status": "Available",
      "url": "/products/wall-flashing-kit-1",
      "cmwUrl": "https://containermodificationworld.com/products/wall-flashing-kit-1",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/container-wall-flashing-kit-main.png?v=1767043262",
      "imageAlt": "Interior view of a container with a Wall Flashing Kit installed around the door frame, highlighted in blue lines; includes self-tapping screws and rivets for secure installation.",
      "summary": "Installation Instructions Wall Flashing Kit Instructions (Download PDF) Included Hardware No.12 7/8\" Hex Head Self-Tapping Screws Steel/Steel, 3/16\", 1/2\", Open Rivets",
      "sku": "CMW-4K-510-0938 | CMW-4K-510-0939",
      "search": "wall flashing kit (standard & high cube) wall-flashing-kit-1 flashing container modification world flashing wall flashing kit cmw-4k-510-0938 | cmw-4k-510-0939 hardware / components"
    },
    {
      "handle": "interior-wood-stud-brackets",
      "title": "WSB™ Interior Wood Stud Bracket Kits",
      "category": "hardware-components",
      "categoryLabel": "Hardware / Components",
      "type": "Framing",
      "vendor": "Container Modification World",
      "price": "$124.95 - $399.95",
      "status": "Available",
      "url": "/products/interior-wood-stud-brackets",
      "cmwUrl": "https://containermodificationworld.com/int-wood-stud-brackets",
      "image": "https://cdn.shopify.com/s/files/1/0918/2996/1069/files/Interior_Wood_Stud_Bracket.png?v=1766519467",
      "imageAlt": "Aluminum interior wood stud bracket for shipping container framing, compatible with 20ft and 40ft containers",
      "summary": "Aluminum U.S. Patent No. 12,509,876 B Available in 10, 20, & 40 packs Interior Wood Stud Brackets (WSB™) are not corrugation dependent.",
      "sku": "CMW-4K-120-0698 | CMW-4K-120-0699 | CMW-4K-120-0700",
      "search": "wsb™ interior wood stud bracket kits interior-wood-stud-brackets framing container modification world brackets framing wood wood framing wood stud brackets cmw-4k-120-0698 | cmw-4k-120-0699 | cmw-4k-120-0700 hardware / components"
    }
  ]
};
